import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default function (element, data) {
    let swiperContainer = element.querySelector('.pharmacies-swiper');
    let swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
    let slides = swiperContainer.querySelectorAll('.swiper-slide');

    const swiperOptions = {
        modules: [Autoplay],
        slidesPerView: 'auto',
        spaceBetween: 10,
        speed: 2000,
        loop: true,
        slidesOffsetBefore: 125,

        autoplay: {
            delay: 1000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        }
    };

    let spaceBetween = swiperOptions.spaceBetween ?? 0;

    let totalSlidesWidth = Array.from(slides).reduce((sum, slide) => {
        return sum + slide.offsetWidth + spaceBetween;
    }, 0);

    let containerWidth = swiperContainer.clientWidth;

    if (slides.length > 1 && totalSlidesWidth < containerWidth * 2.2) {
        let originalSlides = Array.from(slides);

        let currentWidth = totalSlidesWidth;
        while (currentWidth < containerWidth * 2.2) {
            for (const slide of originalSlides) {
                const clone = slide.cloneNode(true);
                swiperWrapper.appendChild(clone);
                currentWidth += slide.offsetWidth + spaceBetween;

                if (currentWidth >= containerWidth * 2.2) break;
            }
        }
    }

    setTimeout(() => {
        element.swiper = new Swiper(swiperContainer, swiperOptions);
    }, 300);
}
